import { useState, useEffect } from 'react'
import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

const usePage = ({ title, breadcrumbs }) => {
  const { dex } = getEnvAndDex()
  const { dexName } = getDexConfig(dex)

  useEffect(() => {
    document.title = `${dexName} Submittals - ${title}`
  }, [dexName, title])

  const [breadcrumbsItems, setBreadcrumbsItems] = useState(breadcrumbs)

  return {
    breadcrumbsItems,
    setBreadcrumbsItems,
  }
}

export default usePage
